<template>
  <v-app id="landing-page" :style="{ 'background-color': colorFondo }">
   <!-- <v-system-bar
      fixed
      dark
      window
      :color="colorBarraFormulario"
      style="-webkit-app-region: drag"
    >
      <v-btn
        icon
        @click.stop="setDrawer(!drawer)"
        :color="'white'"
        v-if="user"
        style="-webkit-app-region: no-drag"
      >
        <v-icon class="ml-1">mdi-menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-icon :color="'white'">mdi-hiking</v-icon>

      <span v-bind:style="{ color: 'white' }"> Rutas Meigas Gestion v0.1  </span>
      <v-spacer></v-spacer>
    
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            :color="'white'"
            style="-webkit-app-region: no-drag"
            @click="_logout"
            class="mr-4"
            v-on="on"
            >mdi-account</v-icon
          >
        </template>
        <span>Cerrar Sesión</span>
      </v-tooltip>

      <v-icon
        :color="'white'"
        style="-webkit-app-region: no-drag"
        @click="_minimizeWin"
        >mdi-minus</v-icon
      >

      <v-icon
        :color="'white'"
        style="-webkit-app-region: no-drag"
        @click="_closeWin"
        >mdi-close</v-icon
      >
    </v-system-bar>-->

    <menu-drawer v-if="access_token" />

    <v-main class="mx-0 mt-0">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MenuDrawer from "./components/MenuDrawer";
import ReservaFormulario from "./components/formularios/ReservaFormulario.vue";
import '@/assets/fonts/fonts.css';

export default {
  name: "App",
  //probando github

  components: {
    MenuDrawer,
    ReservaFormulario
  },

  data: () => ({
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorFondo",
      "colorBarraFormulario",
      "colorAccent1",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
     
  },

  mounted() {
    this.setDark(false);
    this.setThemeVerdeOpacoMostaza(true);
   // this.$router.push("/login");
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    ...mapMutations(["setDark", "setThemeVerdeOpacoMostaza", "setDrawer"]),
   
  
    _closeWin() {
      window.close();
    },

    _minimizeWin() {
      const { remote } = require("electron");
      remote.getCurrentWindow().minimize();
    },

    _changeDark() {
      this.setDark(!this.dark);
    },

    _maximizeWin() {
      const { remote } = require("electron");
      if (remote.getCurrentWindow().isMaximized) {
        window.resizeTo(800, 600);
      } else {
        remote.getCurrentWindow().maximize();
      }
    },

    async _logout() {
      this.setDrawer(false);
      await this.logOut([this.access_token]);
      this.$router.push("/login");
    },
  },
};

//background-image: url("./assets/fondo12.jpg");
</script>

<style>

* {
  text-transform: none !important;
  font-family: 'Mulish', sans-serif;
 
}


body, #landing-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  font-family: 'Mulish', sans-serif;
  
}

html {
  overflow: auto !important;
}

.v-data-table-header {
  background-color: grey;
}
</style>